import React from "react";
import * as RiIcons from "react-icons/ri";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import List from "@material-ui/core/List";
import Logo from "../../../../assets/images/BizinCLOUD Logo Main.png";
import IconHome from "@material-ui/icons/Home";
import IconDashboard from "@material-ui/icons/Dashboard";
import IconReceipt from "@material-ui/icons/Receipt";
import IconSupervisorAccount from "@material-ui/icons/SupervisorAccount";
import IconPerson from "@material-ui/icons/Person";
import IconTruck from "@material-ui/icons/AirportShuttle";
import IconMonetizationOn from "@material-ui/icons/MonetizationOn";
import IconClass from "@material-ui/icons/Class";
import IconProductPrice from "@material-ui/icons/LocalOffer";
import IconPayment from "@material-ui/icons/Payment";
import IconAutorenew from "@material-ui/icons/Autorenew";
import IconGroupAdd from "@material-ui/icons/GroupAdd";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import IconLocationOn from "@material-ui/icons/LocationOn";
import IconSupplier from "@material-ui/icons/Storefront";
import IconShoppingCart from "@material-ui/icons/ShoppingCart";
import IconArrowUpward from "@material-ui/icons/ArrowUpward";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import IconHomeWork from "@material-ui/icons/HomeWork";
import AssesmentIcon from "@material-ui/icons/Assessment";
import IconAddToPhotos from "@material-ui/icons/AddToPhotos";
import IconType from "@material-ui/icons/LocalShipping";
import IconStorage from "@mui/icons-material/PropaneTank";

import { store } from "../../../../redux-store/store";
import AppMenuItem from "./AppMenuItem";

const appMenuItems = [
  {
    name: "Home",
    Icon: IconHome,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    role: "App Owner,Admin,Sales Representative,Inventory Manager",
    items: [
      {
        name: "Dashboard",
        link: "/home",
        Icon: IconDashboard,
        role: "App Owner,Admin",
      },
      {
        name: "Dashboard",
        link: "/main/sales/dashboard",
        Icon: IconDashboard,
        role: "Sales Representative",
      },
      {
        name: "Dashboard",
        link: "/main/admin/dashboard",
        Icon: IconDashboard,
        role: "Inventory Manager",
      },
    ],
  },
  {
    name: "Admin / Setup",
    Icon: IconSupervisorAccount,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    role: "App Owner,Admin",

    items: [
      {
        name: "User Management",
        link: "/main/dashboard",
        Icon: IconPerson,
        role: "App Owner,Admin",
      },
      {
        name: "Location Management",
        link: "/main/locations",
        Icon: IconLocationOn,
        role: "App Owner,Admin",
      },
      {
        name: "Supplier Management",
        link: "/main/supplier",
        Icon: IconSupplier,
        role: "App Owner,Admin",
      },
      {
        name: "Product Category Mgt.",
        link: "/main/product-category",
        Icon: IconAddToPhotos,
        role: "App Owner,Admin",
      },
      {
        name: "Add Pickup Station",
        link: "/main/pickupstation",
        Icon: IconAddToPhotos,
        role: "App Owner,Admin",
      },
      {
        name: "Product Managenent",
        link: "/main/product",
        Icon: IconClass,
        role: "App Owner,Admin",
      },
      {
        name: "Product Price",
        link: "/main/product-price",
        Icon: IconProductPrice,
        role: "App Owner,Admin",
      },
      {
        name: "Logistics Cost",
        link: "/main/logistics",
        Icon: IconTruck,
        role: "App Owner,Admin",
      },
      // {
      //   name: "Truck Type",
      //   link: "/main/truck/truckType",
      //   Icon: IconType,
      //   role: "App Owner,Admin",
      // },
      {
        name: "Storage Tanks",
        link: "/main/storage-tanks",
        Icon: IconStorage,
        role: "App Owner,Admin",
      },
    ],
  },
  // storage
  {
    name: "Inventory",
    // link: "#",
    Icon: IconReceipt,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    role: "App Owner,Admin,Sales Representative,Inventory Manager",

    items: [
      {
        name: "Inventory",
        link: "/main/inventory",
        Icon: IconReceipt,
        role: "App Owner,Admin,Sales Representative,Inventory Manager",
      },
      {
        name: "Incoming Inventory",
        link: "/main/incoming",
        Icon: IconExpandMore,
        role: "App Owner,Admin,Sales Representative,Inventory Manager",
      },
      {
        name: "Outgoing Inventory",
        link: "/main/outgoing",
        Icon: IconArrowUpward,
        role: "App Owner,Admin,Sales Representative,Inventory Manager",
      },
      {
        name: "WareHouse Transfer",
        link: "/main/transfer",
        Icon: IconHomeWork,
        role: "App Owner,Sales Representative,Inventory Manager",
      },
      {
        name: "Inventory Reports",
        link: "/main/reports",
        Icon: AssesmentIcon,
        role: "App Owner,Sales Representative,Inventory Manager",
      },
    ],
  },
  {
    name: "Sales",
    Icon: IconShoppingCart,
    role: "Sales Representative,App Owner",

    items: [
      {
        name: "Items",
        link: "/main/sales",
        Icon: IconShoppingCart,
        role: "Sales Representative",
      },
      {
        name: "Repayments",
        link: "/repayments",
        Icon: IconShoppingCart,
        role: "Sales Representative,App Owner",
      },
      {
        name: "Main Sales",
        link: "/main/sales",
        Icon: ShoppingBasketIcon,
        role: "Sales Representative,App Owner",
      },
      {
        name: "Payments",
        link: "/payments",
        Icon: IconPayment,
        role: "App Owner,Admin,Sales Representative",
      },
      {
        name: "Payment",
        link: "/payments",
        Icon: IconPayment,
        role: "Sales Representative",
      },
      {
        name: "Online Payment",
        link: "/online-payments",
        Icon: IconPayment,
        role: "Sales Representative",
      },
      {
        name: "Add Customer Info.",
        link: "/sales/customer",
        Icon: IconGroupAdd,
        role: "Sales Representative,App Owner",
      },
      {
        name: "Refunds",
        link: "/refunds",
        Icon: IconAutorenew,
        role: "Sales Representative,App Owner",
      },
      /* {
        name: "Saved Orders",
        link: "/orders",
        Icon: IconAddShoppingCart,
        role: "Sales Representative,App Owner",
      },*/
      {
        name: "Sales Report",
        link: "/main/sales-report",
        Icon: IconMonetizationOn,
        role: "App Owner,Admin,Sales Representative",
      },
    ],
  },
];

const AppMenu = () => {
  const classes = useStyles();
  var roles = store.getState().persistReducer.roles;
  return (
    <List component="nav" className={classes.appMenu} disablePadding>
      <img style={{ paddingLeft: "20px" }} src={Logo} alt="Logo" width="40%" />
      {/* <AppMenuItem {...appMenuItems[0]} /> */}
      {appMenuItems.map((item, index) => {
        if (item.role.split(",").includes(roles[0])) {
          return <AppMenuItem {...item} key={index} />;
        }
      })}
    </List>
  );
};

const drawerWidth = 240;

const useStyles = makeStyles((theme) =>
  createStyles({
    appMenu: {
      width: "100%",
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
      color: "#ffffff",
    },
    menuItemIcon: {
      color: "#ffffff",
    },
  })
);

export default AppMenu;
